<template>
  <div >

        <section >
                <div>
                    <!-- Mobile action buttons -->
                    <div class="d-flex d-md-none gap-2 mb-3" v-if="!isDetailSupplier">
                        <button @click="create" v-if="helper.checkAccess('create_receptions') != -1" class="btn btn-sm btn-success flex-grow-1">
                            <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                            <span>{{$t('reception')}}</span>
                        </button>
                    </div>

                    <!-- Filters section -->
                    <div class="row align-items-end g-2 mb-4" v-if="!isDetailSupplier" :class="{'d-none d-md-flex': !showFilters}">
                        
                        <!-- Filter Dropdown (Shopify Style) -->
                        <div class="col-12 col-md-auto">
                            <div class="dropdown">
                                <button class="btn btn-outline-secondary dropdown-toggle btn-sm" type="button" id="receptionFilterDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                    <AppIcon name="bi-funnel" class="bi bi-funnel" /> {{$t('filter')}}
                                    <span v-if="activeFilters.length" class="badge bg-secondary ms-1">{{activeFilters.length}}</span>
                                </button>
                                <button v-if="activeFilters.length" class="btn btn-link btn-sm text-danger text-decoration-none ms-2" type="button" @click.stop="clearAllFilters">
                                    <AppIcon name="bi-x-circle" class="bi bi-x-circle me-1" />{{$t('clear_all')}}
                                </button>
                                <div class="dropdown-menu p-3" aria-labelledby="receptionFilterDropdown" style="min-width: 300px;" @click.stop>
                                    
                                    <!-- Active Filters -->
                                    <div v-if="activeFilters.length > 0" class="mb-3">
                                        <div v-for="(filter, index) in activeFilters" :key="index" class="mb-2">
                                            <label class="form-label small mb-1">{{$t(filter.key)}}</label>
                                            <div class="input-group input-group-sm" v-if="filter.key === 'total_amount'">
                                                <select v-model="filter.operator" class="form-select" style="max-width: 80px;">
                                                    <option value="gt">{{$t('operator_gt')}}</option>
                                                    <option value="lt">{{$t('operator_lt')}}</option>
                                                    <option value="eq">{{$t('operator_eq')}}</option>
                                                </select>
                                                <input type="number" v-model="filter.value" class="form-control form-control-sm" placeholder="0">
                                                <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                                                    <AppIcon name="bi-trash" class="bi bi-trash" />
                                                </button>
                                            </div>
                                            <div class="input-group input-group-sm" v-else>
                                                <select v-model="filter.value" class="form-select form-select-sm">
                                                    <option v-for="option in getFilterOptions(filter.key)" :key="option.value" :value="option.value">
                                                        {{$t(option.label)}}
                                                    </option>
                                                </select>
                                                <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                                                    <AppIcon name="bi-trash" class="bi bi-trash" />
                                                </button>
                                            </div>
                                        </div>
                                        <hr class="dropdown-divider">
                                    </div>

                                    <!-- Add Filter Options -->
                                    <div class="d-grid gap-2">
                                        <button v-for="filter in selectableFilters" :key="filter.key" 
                                                class="btn btn-sm btn-outline-primary text-start" 
                                                @click="addFilter(filter)">
                                            <AppIcon name="bi-plus" class="bi bi-plus" /> {{$t(filter.key)}}
                                        </button>
                                    </div>

                                    <!-- Apply and Clear -->
                                    <div class="d-flex justify-content-between align-items-center mt-3">
                                        <button class="btn btn-sm btn-success" @click="applyFilters">
                                            {{$t('apply')}}
                                        </button>
                                        <button v-if="activeFilters.length > 0" class="btn btn-link btn-sm text-decoration-none text-danger p-0" @click="clearAllFilters">
                                            {{$t('clear_all')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Spacer for desktop -->
                        <div class="col d-none d-md-block"></div>
                        
                        <!-- Date picker -->
                        <div class="col-12 col-md-3 col-lg-2">
                            <label class="form-label small d-md-none mb-1">{{$t('filter_by_date')}}</label>
                            <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select form-select-sm">
                                <option value="">{{$t('filter_by_date')}}</option>
                                <option value="today">{{$t('today')}}</option>
                                <option value="yesterday">{{$t('yesterday')}}</option>
                                <option value="this_week">{{$t('this_week')}}</option>
                                <option value="last_week">{{$t('last_week')}}</option>
                                <option value="this_month">{{$t('this_month')}}</option>
                                <option value="custom">{{$t('custom_date')}}</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-3 col-lg-2" v-if="dateRangeOption === 'custom'">
                            <label class="form-label small d-md-none mb-1">{{$t('custom_date')}}</label>
                            <date-picker :clearable="true" :editable="false" class="w-100" v-model="range" type="date" range :multi-calendars="1" :placeholder="$t('select_date_range')"></date-picker>
                        </div>
                        
                        <!-- Desktop action buttons -->
                        <div class="col-md-2 d-none d-md-block" v-if="helper.checkAccess('create_receptions') != -1">
                            <button @click="create" class="btn btn-sm btn-success w-100">
                                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                <span>{{$t('reception')}}</span>
                            </button>
                        </div>
                    </div>
                <div class="page-table-container mb-6 bg-white rounded shadow">

                    <!-- Bulk Action Bar -->
                    <div v-if="isSelectedItem" class="position-fixed bottom-0 start-50 translate-middle-x mb-4 p-3 bg-white shadow rounded d-flex align-items-center gap-3" style="z-index: 1050; border: 1px solid #dee2e6; min-width: 300px; justify-content: space-between;">
                        <div class="d-flex align-items-center">
                            <span class="fw-bold me-2">{{ selectedCount }}</span>
                            <span class="text-muted">{{$t('selected')}}</span>
                        </div>
                        <div class="d-flex gap-2">
                            <div v-if="helper.checkAccess('create_supplier_invoices') > 0" class="dropdown dropup">
                                <button class="btn btn-primary btn-sm dropdown-toggle d-flex align-items-center" type="button" id="bulkTransferDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                    <AppIcon name="bi-arrow-left-right" class="bi bi-arrow-left-right me-1" /> {{$t('transfert')}}
                                </button>
                                <ul class="dropdown-menu" aria-labelledby="bulkTransferDropdown">
                                    <li><a class="dropdown-item" style="cursor:pointer" @click="transferSelectedToInvoice"> {{$t('invoice')}}</a></li>
                                </ul>
                            </div>
                            <button v-if="helper.checkAccess('delete_receptions') != -1" class="btn btn-danger btn-sm d-flex align-items-center" @click="deleteSelected">
                                <AppIcon name="bi-trash" class="bi bi-trash me-1" /> {{$t('delete')}}
                            </button>
                        </div>
                    </div>

                    <!-- table -->
                    <div class="table-responsive">
                        <table class="table mb-0 table-borderless table-striped small">
                            <thead>
                                <tr class="text-secondary">
                                    <th class="pt-4 pb-3 px-6" style="width: 40px;">
                                        <div class="form-check mb-0">
                                            <input class="form-check-input" type="checkbox" :checked="areAllSelected" @change="toggleSelectAll">
                                        </div>
                                    </th>
                                    <sortable-table-header field="reference" label="reference" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getReceptions)" />
                                    <sortable-table-header field="purchase" label="purchase" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getReceptions)" />
                                    <sortable-table-header v-if="!hideSupplier" field="supplier" label="supplier" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getReceptions)" />
                                    <sortable-table-header field="status" label="status" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getReceptions)" />
                                    <sortable-table-header field="date" label="date" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getReceptions)" />
                                    <sortable-table-header field="created_by" label="created_by" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getReceptions)" />
                                    <th class="pt-4 pb-3 px-6">{{$t('action')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="reception in receptions" :key="reception.id" :class="{'table-active': reception.selected}">
                                <td class="py-5 px-6">
                                    <div class="form-check mb-0">
                                        <input class="form-check-input" type="checkbox" v-model="reception.selected" @change="changeSelectedItem">
                                    </div>
                                </td>
                                <td class="py-5 px-6"><router-link  :to="`/receptions/${reception.id}`"><b>{{reception.reference}}</b></router-link></td>
                                <td class="py-5 px-6"><router-link v-if="reception.purchase && reception.purchase.reference" :to="`/purchases/${reception.purchase.id}`">{{reception.purchase && reception.purchase.reference ? reception.purchase.reference : "-"}}</router-link></td>
                                <td  v-if="!hideSupplier" class="py-5 px-6"> <router-link v-if="reception.supplier && reception.supplier.name" :to="`/suppliers/${reception.supplier.id}`">{{reception.supplier && reception.supplier.name ? reception.supplier.name : '-'}}</router-link></td>
                                <td class="py-5 px-6">
                                    <div v-if="helper.checkAccess('edit_receptions') != -1" class="dropdown">
                                        <button
                                            :id="`reception-status-${reception.id}`"
                                            type="button"
                                            class="badge border-0 dropdown-toggle"
                                            :class="getReceptionStatusBadgeClass(reception.status)"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            :disabled="isReceptionStatusDropdownDisabled(reception)"
                                        >
                                            <span v-if="statusUpdatingReceptionId === reception.id" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                            {{ $t(reception.status) }}
                                        </button>
                                        <ul class="dropdown-menu shadow" :aria-labelledby="`reception-status-${reception.id}`">
                                            <li v-for="status in getReceptionStatusOptions()" :key="status">
                                                <button
                                                    type="button"
                                                    class="dropdown-item d-flex align-items-center justify-content-between gap-3"
                                                    :class="{ active: reception.status === status }"
                                                    @click="changeReceptionStatus(reception, status)"
                                                >
                                                    <span>{{ $t(status) }}</span>
                                                    <AppIcon name="bi-check-lg" v-if="reception.status === status" class="bi bi-check-lg" />
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <span v-else class="badge" :class="getReceptionStatusBadgeClass(reception.status)">
                                        {{ $t(reception.status) }}
                                    </span>
                                </td>
                                <td class="py-5 px-6">{{formatDate(reception.date)}}</td>
                                <td class="py-5 px-6">
                                    {{reception.user ? reception.user.name : '-'}}
                                </td>
                                <td class="py-5 px-6">
                                    
                                    <button v-if="reception.status != 'draft' && helper.checkAccess('create_supplier_invoices') > 0" class="btn btn-primary btn-xs dropdown-toggle" type="button" id="dropdownMenuButton1" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" data-bs-toggle="dropdown" aria-expanded="false">
                                        <AppIcon name="bi-arrow-left-right" class="bi bi-arrow-left-right" style="font-size:12px" /> {{$t('transfert')}}
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><a class="dropdown-item" style="cursor:pointer" @click="transferInvoice(reception)"> {{$t('invoice')}}</a></li>
                                    </ul>
                                    <button v-if="reception.status != 'draft'" @click="ViewReception(reception)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                        {{$t('reception')}}</button>
                                    <button v-if="helper.checkAccess('edit_receptions') != -1" @click="editRow(reception)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                                        {{$t('edit')}}
                                    </button>
                                    <button v-if="helper.checkAccess('delete_receptions') != -1" @click="deleteRow(reception)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                                        {{$t('delete')}}
                                    </button>
                    
                                </td>
                            </tr>

                            </tbody>
                        </table>

                        <div v-if="count > receptions.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <compact-pagination :pages="pagination" :current-page="page" @change="getReceptions" />
                        </div>
                    </div>
                    <!-- table -->
                    <table-loading-bar v-if="loading" class="page-table-state text-center" />
                    <div v-if="loading === false && !receptions.length && !isFiltered" class="page-table-state text-center py-5 my-5 bg-white rounded shadow-sm border" style="border-style: dashed !important;">
                        <AppIcon name="bi-inbox" class="bi bi-inbox text-muted" style="font-size: 3rem;" />
                        <h4 class="mt-3">{{ $t('no_receptions_added') }}</h4>
                        <p class="text-muted">{{ $t('start_by_adding_receptions') }}</p>
                        <template v-if="helper.checkAccess('create_receptions') != -1">
                            <button class="btn btn-outline-primary mt-2" @click="create">
                                {{ $t('create_first_reception') }}
                            </button>
                        </template>
                    </div>
                    <div v-if="loading === false && !receptions.length && isFiltered" class="page-table-state text-center" style="padding:1rem">{{$t('no_reception_found')}}.</div>

                </div>
                <div class="col-sm-7">
                           {{$t('show')}}
                            <select v-model="per_page" class="form-select mb-3" name="Resulats" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="15">15</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            {{$t('entities')}}
                </div>
                </div>
        </section>

    
        <!-- create Modal -->
        <add-edit-reception-modal 
            v-if="createModalisOpen" 
            @modalClosed="createModalisOpen = false"
            modalId="create-purchase-modal-01" 
            :isModalOpen="createModalisOpen" 
            :data="reception" 
            action="create"
            @refresh="refresh"
        ></add-edit-reception-modal>
        <!-- create modal -->

        <!-- Edit Modal -->
        <add-edit-reception-modal 
            v-if="editModalisOpen" 
            @modalClosed="editModalisOpen = false" 
            modalId="edit-reception-modal-01" 
            :isModalOpen="editModalisOpen"  
            :data="reception" 
            action="update" 
            @refresh="refresh"
        ></add-edit-reception-modal>
        <!-- Edit modal -->

        <!-- quote modal -->
        <invoice-template-modal 
            v-if="invoiceModalisOpen" 
            @modalClosed="invoiceModalisOpen = false" 
            modalId="invoice-reception-modal-01" 
            :isModalOpen="invoiceModalisOpen"  
            :data="reception" 
            type="reception">
        </invoice-template-modal>
        <!-- quote modal -->


        <!-- create Modal -->
        <add-edit-invoice-modal 
            v-if="createInvoiceModalState" 
            @modalClosed="createInvoiceModalState = false"
            modalId="create-purchase-modal-01" 
            :isModalOpen="createInvoiceModalState" 
            :data="reception" 
            action="transfer"
        ></add-edit-invoice-modal>
        <!-- create modal -->

        <div v-if="createProductState">
            <add-product :state="createProductState"  @createProduct="createProduct"></add-product>
        </div>

  </div>
</template>

<script>
import helper from '../helper'
import AddProduct from '../components/AddProduct.vue'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'

import AddEditReceptionModal from '../components/reception/AddEditReceptionModal'
import AddEditInvoiceModal from '../components/supplierInvoice/AddEditInvoiceModal'

import InvoiceTemplateModal from '../components/invoiceLayout/InvoiceTemplateModal';
import sortableList from '../mixins/sortableList';

export default {
  name: 'Reception',
  persistedFilterState: {
    key: 'receptions',
    fields: ['activeFilters', 'dateRangeOption', 'range', 'start', 'end', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
  },
  mixins: [sortableList],
  components : {
    DatePicker,
    AddProduct,
    AddEditReceptionModal,
    AddEditInvoiceModal,
    InvoiceTemplateModal
   },
    props : [
    'openCreateModal',
    'supplier_id',
    'supplier',
    'purchase_id',
    'products',
    'keyword',
    'isDetailSupplier',
    'showFilters',
    'product_id'
   ],
  data(){
    return {
        loading : false,
        statusUpdatingReceptionId: null,
        refreshComponent : true,
        search :'',
        receptions : [],
        count : 0,
        page : 1,
        transactions : [],
        reception : {
            id : null,
            reference : `RECEPTION-00`,
            date : '',
            notes : '',
            products : [],
            new_products : [],
            purchase_id : null,
            status : 'pending',
        },
        range: [],
        start : null,
        end : null,
        dateRangeOption: '',
        activeFilters: [],
        availableFilters: [
            { 
                key: 'status', 
                options: [
                    { value: 'draft', label: 'draft' },
                    { value: 'pending', label: 'pending' },
                    { value: 'received', label: 'received' }
                ] 
            }
        ],
        deliveryProducts : [],
        totalHtPrice : 0,
        createModal : null,
        editModal : null,
        invoiceModalStatus : false,
        invoiceModalisOpen : false,
        createModalisOpen :false,
        editModalisOpen :false,
        createSuplierState : false,
        createInvoiceModalState : false,
        per_page : 25,
        pagination : [],
        hideSupplier : false,
        createProductState : false,
        url : '',
        createPaymentModalState : false,
        invoiceData : {},
        isSelectedItem: false
    }
  },
  created(){
    
  },
  mounted(){
    // Initialize this_month date range
    // this.handleDateRangeChange()

    if(this.isDetailSupplier && this.isDetailSupplier == true){
        this.hideSupplier = true
    }

    this.getReceptions()

  },
  watch : {
    range(val) {
        if (val && val.length === 2 && val[0] && val[1]) {
            this.start = moment(val[0]).format('YYYY-MM-DD')
            this.end = moment(val[1]).format('YYYY-MM-DD')
            this.getReceptions(1)
        } else {
            this.start = null
            this.end = null
            this.getReceptions(1)
        }
    },
    per_page(){
        this.getReceptions(this.page)
    },
    openCreateModal(){
        this.createModalStatus = this.openCreateModal
        this.create()
    },
    createModalisOpen(){
        this.getReceptions()
        this.$emit('createModalStatus',this.createModalisOpen)
    },
    async keyword(){
        if(this.keyword.length > 2){
            const response = await helper.customGet(`${process.env.VUE_APP_API}/receptions?keyword=${this.keyword}&per_page=${this.per_page}`)
            this.receptions = response.data.data
            this.count = response.data.count
        }
        if(this.keyword == '') return this.getReceptions()
    },
  },    
  methods : {
    async create(){
        
        this.clearForm()
        
        if(this.supplier){
            this.reception.supplier = this.supplier
        }

        if(this.supplier_id){
            this.reception.supplier_id = this.supplier_id
        }

        if(this.purchase_id){
            this.reception.purchase_id = this.purchase_id
        }

        if(this.products){
            for(let i = 0 ; i < this.products.length ; i++){
                this.products[i].label = this.products[i].product_label 
            }
            this.reception.products = this.products
        }


        this.reception.products.push({
            label : '',
            id : null,
            quantity : 0,
            price : 0,
            discount : 0,
            vat : 0,
            total : 0,
            sub_total : 0,
        })

        this.createModalisOpen = true;
        this.reception.date = moment().format('YYYY-MM-DD')
    },
    editRow(row){
        this.editModalisOpen = true;
        this.clearForm()
        this.reception = row 
        this.reception.supplier_id = row.supplier && row.supplier.id ? row.supplier.id : null
        this.reception.date = moment(this.reception.date).format('YYYY-MM-DD')
    },
    ViewReception(row){
        this.invoiceData = row
        this.reception = row
        this.invoiceModalisOpen = true;
    },
    //create reception
    async saveRow(){
        try{
            this.loading = true
            this.reception.products = helper.formatProducts(this.reception.products)
            await helper.customPost(`${process.env.VUE_APP_API}/receptions`, {...this.reception, products : [...this.reception.products]},{showToast:true})
            this.loading = false
            this.getReceptions()
            this.clearForm()
            this.createModal.hide()
        }catch(error){
            this.loading = false
        }

    },
    //update reception
    async updateRow(){
        try{
            this.loading = true
            this.reception.products = helper.formatProducts(this.reception.products)
            await helper.customPatch(`${process.env.VUE_APP_API}/receptions/${this.reception.id}`,{...this.reception, products : [...this.reception.products]})
            this.loading = false
            this.clearForm()
            this.editModal.hide()
            this.getReceptions()
        }catch(error){
            this.loading = false
        }

    },
    viewRow(row){
        this.clearForm()
        this.reception = row 
        this.invoiceModalisOpen = true;
    },
    previewRow(){
        this.invoiceModalisOpen = true;
    },
    async deleteRow(row){
        this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text : this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
            }).then(async (result) => {
            if (result.isConfirmed) {
                await helper.customDelete(`${process.env.VUE_APP_API}/receptions/${row.id}`)
                this.receptions = helper.withoutDeletedRecords(this.receptions, row.id)
                this.count = Math.max(0, this.count - 1)
            }
        })
    },
    clearForm(){
        this.reception = {
            id : null,
            reference : '',
            date : '',
            products : [],
            new_products : [],
            status : 'pending',
        }

    },
    async getReceptions(page){
        try{
            this.loading = true
            this.page = page ? page : 1
            
            // Extract filters
            const statusFilter = this.activeFilters.find(f => f.key === 'status');
            const status = statusFilter ? statusFilter.value : 'all';

            const amountFilter = this.activeFilters.find(f => f.key === 'total_amount');

            // Build query params
            const params = new URLSearchParams();
            params.append('page', this.page);
            params.append('per_page', this.per_page);
            this.appendSortParams(params);

            if (this.start) {
                params.append('start', this.start);
                params.append('end', this.end);
            }

            if (status !== 'all') params.append('status', status);
            
            if (amountFilter && amountFilter.value !== null && amountFilter.value !== '') {
                params.append('amount_operator', amountFilter.operator);
                params.append('amount_value', amountFilter.value);
            }
            
            // Add optional filters if they exist
            if (this.supplier_id) params.append('supplier_id', this.supplier_id);
            if (this.purchase_id) params.append('purchase_id', this.purchase_id);
            if (this.product_id) params.append('product_id', this.product_id);
            if (this.keyword && this.keyword.length > 2) params.append('keyword', this.keyword);

            let url = `${process.env.VUE_APP_API}/receptions?${params.toString()}`;

            const response = await helper.customGet(url)
            this.receptions = response.data.data
            for(let i = 0 ; i < this.receptions.length ; i++){
                this.$set(this.receptions[i], 'selected', false)
            }
            this.count = response.data.count
            if(this.per_page != response.data.per_page){
                this.per_page = response.data.per_page
            }
            //pagination
            this.pagination = []
            let MaxPagination = Math.ceil(this.count / this.per_page )
            for(let i = 1 ; i <= MaxPagination ;i++){
                this.pagination.push(i)
            }
            this.loading = false
        }catch(error){
            this.loading = false
        }

    },
    transferInvoice(reception){

        reception.total = reception.products && reception.products.length ? reception.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;
        this.reception = reception
        this.createInvoiceModalState = !this.createInvoiceModalState
    },
    emitAutoComplete(data){
        if(!this.localData.products.length || !this.localData.products.find(product => product.product_id == data.result.product.id)){
            this.reception.products[data.index] = {
                ...{
                inventory_id : data.result.id,
                label : data.result.product.label || data.result.product.product_label,
                product_label : data.result.product.label || data.result.product.product_label,
                id : data.result.product.id,
                product_id : data.result.product.id,
                price : data.result.price,
                purchase_price : data.result.purchase_price,
                quantity : 0,
                maxQty : data.result.quantity,
                vat :  data.result.vat ? data.result.vat : 20,
                total : data.result.total ? data.result.total : 0,
                sub_total : data.result.sub_total ? data.result.sub_total : 0,
            }}
            this.reception.products = [...this.reception.products]
        }
    },
    emitAutoCompletePurchase(data){
        this.reception.products = data.result.products
        this.reception.purchase_id = data.result.id
        if(data.result.supplier){
            this.reception.supplier = data.result.supplier
            this.reception.supplier_id = data.result.supplier.id
        }
    },
    createProduct(data){
        if(data.product && data.inventory){
            data.product.product_label = data.product.label
            data.product.maxQty = data.inventory.quantity
            data.product.quantity = 0
            data.product.price = data.inventory.price
            data.product.purchase_price = data.inventory.purchase_price
            data.product.inventory_id = data.inventory.id
            data.product.product_id = data.product.id
            data.product.vat = 20
            data.product.new_product = true
            this.reception.products.push(data.product)
        }

        if(data && data.state != undefined){
            this.createProductState = data.state
        }
        this.calculatePrices()
    },
    getStatus(status){
       if(status == 'paid'){
         return 'badge bg-success rounded-pill small'
       }else if(status == 'partially_paid'){
         return 'badge bg-success rounded-pill small'
       }else if(status == 'pending'){
         return 'badge bg-primary rounded-pill small'
       }else if(status == 'refunded'){
         return 'badge bg-info rounded-pill small'
       }
    },
    getReceptionStatusBadgeClass(status){
        return {
            'bg-info': status === 'draft',
            'bg-success': status === 'completed' || status === 'received',
            'bg-warning': status === 'partially_received',
            'bg-danger': status === 'canceled',
            'bg-secondary': status === 'pending'
        }
    },
    getReceptionStatusOptions(){
        const filter = this.availableFilters.find(filter => filter.key === 'status')
        return filter ? filter.options.map(option => option.value) : []
    },
    isReceptionStatusDropdownDisabled(reception){
        return this.statusUpdatingReceptionId === reception.id
    },
    async changeReceptionStatus(reception, status){
        if (this.isReceptionStatusDropdownDisabled(reception) || reception.status === status) return

        const toggle = document.getElementById(`reception-status-${reception.id}`)
        let statusDropdown = null
        if (toggle) {
            // eslint-disable-next-line no-undef
            statusDropdown = bootstrap.Dropdown.getInstance(toggle) || new bootstrap.Dropdown(toggle)
            statusDropdown.hide()
        }

        const previousStatus = reception.status
        this.statusUpdatingReceptionId = reception.id
        this.$set(reception, 'status', status)

        try{
            await helper.customPatch(
                `${process.env.VUE_APP_API}/receptions/${reception.id}`,
                { status },
                { showToast: true }
            )
            if (statusDropdown) statusDropdown.hide()
        }catch(error){
            this.$set(reception, 'status', previousStatus)
        }finally{
            await this.getReceptions(this.page)
            this.statusUpdatingReceptionId = null
        }
    },
    openCreateSupplierModal(){
        this.createSuplierState = !this.createSuplierState
    },
    calculatePrices(){
        this.$forceUpdate();

        for(let i = 0 ; i < this.reception.products.length ; i++){
        this.reception.products[i].total = parseFloat(this.reception.products[i].price) * parseFloat(this.reception.products[i].quantity)
            this.reception.products[i].sub_total = Math.round(parseFloat(this.reception.products[i].total))

            if(this.reception.products[i].vat > 0){
                this.reception.products[i].total += parseFloat((parseFloat(this.reception.products[i].total) * parseFloat(this.reception.products[i].vat / 100)).toFixed(2))
                this.reception.products[i].total = Math.round(this.reception.products[i].total)
            }
        }   
        this.reception.total = this.reception.products && this.reception.products.length ? this.reception.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;
        this.totalHtPrice = this.reception.products && this.reception.products.length ? this.reception.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0;
        this.purchasePrice = this.reception.products && this.reception.products.length ? this.reception.products.map(o => o.purchase_price).reduce((a, c) => { return a + c }) : 0;
    },
    parseTTctoHt(index,price){
        if(price && price > 0){
           this.reception.products[index].price = ((price / this.reception.products[index].quantity) / 1.2).toFixed(2)
           this.reception.products[index].sub_total = parseFloat(this.reception.products[index].price) * parseFloat(this.reception.products[index].quantity)
        }
    },
    emitAutoCompleteSupplier(data){
        this.reception.supplier_id = data.result.id
        this.reception.supplier = data.result
    },
    generatePDF() {
        const doc = new jsPDF();

        const data = []
        for(let i = 0 ; i < this.receptions.length ; i++){
            const reception = this.receptions[i]
            data.push([
                reception.reference,
                reception.purchase && reception.purchase.reference ? reception.purchase.reference : "-",
                reception.purchase && reception.purchase.supplier && reception.purchase.supplier.name ? reception.purchase.supplier.name : '-',
                reception.status
            ])
        }
        doc.text("Receptions", 15, 10);
        autoTable(doc,
        {
            head: [["Id", "Achat","Fournisseur", "Status","Date"]],
            body: data
        })
        doc.save('receptions.pdf')
    },
    openCreateProductModal(){
        this.createProductState = !this.createProductState
    },
    createPaymentModal(data){
        this.createPaymentModalState = data
    },
    refresh(){
        this.getReceptions()
    },
    //helper functions
    formatDate(date) { return helper.formatDate(date) },
    formatMoney(number) { return helper.formatMoney(number);},
    formatReference(number,id) { return helper.formatReference(number,id);},
    // Handle date range selection
    handleDateRangeChange() {
      const option = this.dateRangeOption
      if (!option || option === 'custom') {
        if (option === 'custom') return
        this.range = []
        this.start = null
        this.end = null
        this.getReceptions()
        return
      }

      const today = moment()
      let start, end

      switch(option) {
        case 'today':
          start = today.clone().startOf('day')
          end = today.clone().endOf('day')
          break
        case 'yesterday':
          start = today.clone().subtract(1, 'days').startOf('day')
          end = today.clone().subtract(1, 'days').endOf('day')
          break
        case 'this_week':
          start = today.clone().startOf('isoWeek')
          end = today.clone().endOf('isoWeek')
          break
        case 'last_week':
          start = today.clone().subtract(1, 'weeks').startOf('isoWeek')
          end = today.clone().subtract(1, 'weeks').endOf('isoWeek')
          break
        case 'this_month':
          start = today.clone().startOf('month')
          end = today.clone().endOf('month')
          break
        default:
          return
      }

      this.range = [start.toDate(), end.toDate()]
      this.start = start.format('YYYY-MM-DD')
      this.end = end.format('YYYY-MM-DD')
      this.getReceptions()
    },
    addFilter(filter) {
        if (!this.isFilterActive(filter.key)) {
            if (filter.key === 'total_amount') {
                 this.activeFilters.push({
                    key: filter.key,
                    operator: 'gt',
                    value: 0
                });
            } else {
                const defaultVal = filter.options[0].value;
                this.activeFilters.push({ 
                    key: filter.key, 
                    value: defaultVal 
                });
            }
        }
    },
    removeFilter(index) {
        this.activeFilters.splice(index, 1);
    },
    isFilterActive(key) {
        return this.activeFilters.some(f => f.key === key);
    },
    getFilterOptions(key) {
        const filter = this.availableFilters.find(f => f.key === key);
        return filter ? filter.options : [];
    },
    applyFilters() {
        this.getReceptions();
    },
    clearAllFilters() {
        this.activeFilters = [];
        this.getReceptions();
    },
    changeSelectedItem(){
        this.isSelectedItem = this.receptions.find(item => item.selected === true ) ? true : false
    },
    toggleSelectAll() {
      const newState = !this.areAllSelected;
      this.receptions.forEach(item => item.selected = newState);
      this.changeSelectedItem();
    },
    async deleteSelected() {
      const selectedIds = this.receptions.filter(item => item.selected).map(item => item.id);
      if (selectedIds.length === 0) return;

      this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      }).then(async (result) => {
        if (result.isConfirmed) {
            this.loading = true;
            try {
                const results = await Promise.allSettled(selectedIds.map(id => helper.customDelete(`${process.env.VUE_APP_API}/receptions/${id}`)));
                const deletedIds = helper.fulfilledRecordIds(selectedIds, results);
                this.receptions = helper.withoutDeletedRecords(this.receptions, deletedIds);
                this.count = Math.max(0, this.count - deletedIds.length);
                if (deletedIds.length !== selectedIds.length) throw results.find(result => result.status === 'rejected').reason;
                this.isSelectedItem = false;
                this.$toast.open({
                    message: this.$t('receptions_deleted_successfully'),
                    type: 'success',
                    position: 'bottom'
                });
            } catch (error) {
                this.$toast.open({
                    message: this.$t('error_occurred'),
                    type: 'error',
                    position: 'bottom'
                });
            } finally {
                this.loading = false;
            }
        }
      });
    },
    validateBulkTransfer() {
        const selectedReceptions = this.receptions.filter(item => item.selected);
        if (selectedReceptions.length === 0) return null;

        const supplierId = selectedReceptions[0].supplier_id;
        const allSameSupplier = selectedReceptions.every(o => o.supplier_id === supplierId);

        if (!allSameSupplier) {
            this.$swal.fire(
                this.$t('error'),
                this.$t('select_receptions_same_supplier'),
                'error'
            );
            return null;
        }
        
        // Aggregate products
        let allProducts = [];
        selectedReceptions.forEach(o => {
            if (o.products && o.products.length) {
                allProducts = allProducts.concat(o.products);
            }
        });

        // Calculate total
        const total = allProducts.reduce((acc, p) => acc + (p.total || 0), 0);

        return {
            id: null,
            reception_ids: selectedReceptions.map(o => o.id),
            supplier_id: supplierId,
            status : 'pending',
            supplier: selectedReceptions[0].supplier,
            date: moment().format('YYYY-MM-DD'),
            products: allProducts,
            total: total
        };
    },
    transferSelectedToInvoice() {
        const mergedData = this.validateBulkTransfer();
        if (!mergedData) return;

        this.reception = mergedData;
        this.createInvoiceModalState = true;
    }
  },
  computed : {
    selectableFilters() {
        return this.availableFilters.filter(f => !this.isFilterActive(f.key));
    },
    isFiltered() {
      return (this.activeFilters.length > 0) ||
             (this.dateRangeOption && this.dateRangeOption !== '') ||
             (this.keyword && this.keyword.length > 0) ||
             (this.range && this.range.length > 0);
    },
    role(){ return this.$store.getters.ROLE },
    helper(){ return helper },
    permissions(){ return this.$store.getters.PERMISSIONS },
    business(){ return this.$store.getters.BUSINESS},
    total(){ return this.reception.products.length ? this.reception.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0},
    sub_total(){ return this.reception.products.length ? this.reception.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0},
    selectedCount() {
      return this.receptions.filter(item => item.selected).length;
    },
    areAllSelected() {
      return this.receptions.length > 0 && this.receptions.every(item => item.selected);
    }
  }
}

</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
